module.exports = __webpack_public_path__ + "static/media/NASA-logo.cab97810.png";